import MiningManage from './index';
import Award from './award';
import Rate from './rate';
import Flexible from './flexible';
import Regular from './regular';
import RegularDetail from './regular/components/regularDetail';
import NewCoin from './newCoin';
import NewCoinDetail from './newCoin/components/newCoinDetail';
import Alive from './alive';
export default {
    path: '/home/mining/manage',
    component: MiningManage,
    children: [
        {path: '/home/mining/manage/rate', component: Rate},
        {path: '/home/mining/manage/award', component: Award},
        {path: '/home/mining/flexible', component: Flexible},
        {path: '/home/mining/regular', component: Regular},
        {path: '/home/mining/regularDetail', component: RegularDetail},
        {path: '/home/mining/newCoin', component: NewCoin},
        {path: '/home/mining/newCoinDetail', component: NewCoinDetail},
        {path: '/home/mining/alive', component: Alive},

    ]
};
